import { AccountService } from '@services/accountService';

export const useAccountService = (): AccountService => {
  return AccountService.getInstance();
};
